"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktaAuthProvider = void 0;
var constants_1 = require("../constants");
var auth_error_1 = require("../model/auth.error");
var auth_user_1 = require("../model/auth.user");
var user_info_1 = require("../model/user.info");
var model_1 = require("../model");
var OktaAuth = require('@okta/okta-auth-js');
var createAuthUser = function (data, config) {
    var claims = data.claims;
    // Attrib maps in configuration
    var attributesMap = config.provider.okta.userAttributeMap;
    var preferredUsername = claims[String(attributesMap.preferred_username)];
    if (claims.sub && preferredUsername) {
        var userInfo_1 = {
            preferred_username: preferredUsername,
            profile: 'ACTIVE',
            customAttributes: {},
        };
        var _loop_1 = function (key, value) {
            if (key === 'sub') {
                return "continue";
            }
            // Check if key mapping is present in configuration
            var keyMaps = Object.entries(attributesMap).filter(function (_a) {
                var standardKey = _a[0], oktaKey = _a[1];
                return key === oktaKey;
            });
            if (keyMaps.length !== 0) {
                keyMaps.forEach(function (keyMap) {
                    // tslint:disable-next-line
                    var standardKey = keyMap[0], oktaKey = keyMap[1];
                    userInfo_1[standardKey] = value;
                });
            }
            else if (userInfo_1.customAttributes !== undefined) {
                userInfo_1.customAttributes[key] = value;
            }
        };
        for (var _i = 0, _a = Object.entries(claims); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            _loop_1(key, value);
        }
        var authUser = new auth_user_1.default(userInfo_1.preferred_username, new user_info_1.UserInfo(claims.sub, claims.sub, userInfo_1));
        return authUser;
    }
    throw new Error('sub or userName attrb is missing');
};
var OktaAuthProvider = /** @class */ (function () {
    function OktaAuthProvider(config) {
        this.config = config;
        this.authClient = new OktaAuth({
            issuer: this.config.provider.okta.issuer,
            clientId: this.config.provider.okta.clientId,
            redirectUri: this.config.provider.okta.redirectUri,
            tokenManager: {
                storage: this.config.provider.okta.storage
            }
        });
    }
    /**
     * Log In
     * @param username
     * @param password
     */
    OktaAuthProvider.prototype.signIn = function (userName, password, locale) {
        return __awaiter(this, void 0, void 0, function () {
            var transaction, res, _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 6, , 7]);
                        return [4 /*yield*/, this.authClient.signIn({
                                username: userName,
                                password: password
                            })];
                    case 1:
                        transaction = _b.sent();
                        if (!(transaction.status === 'SUCCESS')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.authClient.token.getWithoutPrompt({
                                responseType: ['id_token', 'token'],
                                scopes: ['openid', 'email', 'profile'],
                                sessionToken: transaction.sessionToken
                            })];
                    case 2:
                        res = _b.sent();
                        this.authClient.tokenManager.add('idToken', res.tokens.idToken);
                        this.authClient.tokenManager.add('accessToken', res.tokens.accessToken);
                        _a = createAuthUser;
                        return [4 /*yield*/, this.authClient.tokenManager.get('idToken')];
                    case 3: return [2 /*return*/, _a.apply(void 0, [_b.sent(), this.config])];
                    case 4: throw new Error('Invalid Credentials');
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        e_1 = _b.sent();
                        console.log(JSON.stringify(e_1));
                        switch (e_1.errorCode) {
                            case 'E0000004':
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.INVALID_CREDENTIAL, constants_1.ErrorCodeEnum.INVALID_CREDENTIAL);
                            case 'UserNotConfirmedException':
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.PENDING_VERIFICATION, constants_1.ErrorCodeEnum.PENDING_VERIFICATION);
                            case constants_1.ErrorCodeEnum.PENDING_CHANGE_PASSWORD:
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.PENDING_VERIFICATION, constants_1.ErrorCodeEnum.PENDING_CHANGE_PASSWORD);
                            case constants_1.ErrorCodeEnum.MISSING_PARAMETER:
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.MISSING_PARAMETER, constants_1.ErrorCodeEnum.PENDING_CHANGE_PASSWORD);
                            case constants_1.ErrorCodeEnum.LOCKED:
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.LOCKED, constants_1.ErrorCodeEnum.LOCKED);
                            default:
                                throw e_1;
                        }
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sign up with username, password and other attrbutes like phone, email
     * @param params
     */
    OktaAuthProvider.prototype.signUp = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var res, apiError;
            return __generator(this, function (_a) {
                try {
                    res = {
                        sub: '',
                        preferred_username: '',
                        isUserConfirmed: false
                    };
                    return [2 /*return*/, res];
                }
                catch (e) {
                    apiError = e.errorResponse.errors && e.errorResponse.errors.length
                        ? e.errorResponse.errors[0]
                        : undefined;
                    if (!apiError) {
                        throw e;
                    }
                    switch (apiError.reason) {
                        case constants_1.ErrorCodeEnum.INVALID_EMAIL_FORMAT:
                            throw new auth_error_1.default(apiError.message, constants_1.ErrorCodeEnum.INVALID_EMAIL_FORMAT);
                        case constants_1.ErrorCodeEnum.WEAK_PASSWORD:
                            throw new auth_error_1.default(apiError.message, constants_1.ErrorCodeEnum.WEAK_PASSWORD);
                        default:
                            throw new auth_error_1.default(e.message, constants_1.ErrorCodeEnum.SYSTEM_ERROR);
                    }
                    throw e;
                }
                return [2 /*return*/];
            });
        });
    };
    OktaAuthProvider.prototype.signUpUserProfile = function (params, res) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                }
                catch (e) {
                    throw e;
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Send the verification code to confirm sign up
     * @param username
     * @param code
     */
    OktaAuthProvider.prototype.confirmSignUp = function (userName, code, transactionId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, 'SUCCESS'];
                }
                catch (e) {
                    throw e;
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Request to resend the verification code
     * @param username
     */
    OktaAuthProvider.prototype.resendSignUp = function (username) {
        return __awaiter(this, void 0, void 0, function () {
            var delivery;
            return __generator(this, function (_a) {
                try {
                    delivery = {
                        attributeName: '',
                        deliveryMedium: '',
                        destination: ''
                    };
                    return [2 /*return*/, delivery];
                }
                catch (e) {
                    throw e;
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * logout
     */
    OktaAuthProvider.prototype.signOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.authClient.signOut();
                return [2 /*return*/, 'SUCCESS'];
            });
        });
    };
    /**
     * Change password by authenticated user
     * @param user
     * @param oldPassword
     * @param newPassword
     */
    OktaAuthProvider.prototype.changePassword = function (userName, oldPassword, newPassword) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, 'SUCCESS'];
                }
                catch (e) {
                    throw e;
                }
                return [2 /*return*/, 'SUCCESS'];
            });
        });
    };
    /**
     * Initiate a forgot password request
     * @param username
     */
    OktaAuthProvider.prototype.forgotPassword = function (userName) {
        return __awaiter(this, void 0, void 0, function () {
            var delivery;
            return __generator(this, function (_a) {
                try {
                    delivery = {
                        attributeName: '',
                        deliveryMedium: '',
                        destination: ''
                    };
                    return [2 /*return*/, delivery];
                }
                catch (e) {
                    throw e;
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param username
     * @param code
     * @param password
     */
    OktaAuthProvider.prototype.forgotPasswordSubmit = function (userName, code, password) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, 'SUCCESS'];
                }
                catch (e) {
                    throw e;
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Get current authenticated user
     * @param params
     */
    OktaAuthProvider.prototype.currentAuthenticatedUser = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = createAuthUser;
                        return [4 /*yield*/, this.authClient.tokenManager.get('idToken')];
                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent(), this.config])];
                }
            });
        });
    };
    /**
     * Get current user's session
     */
    OktaAuthProvider.prototype.currentSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var idToken, accessToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authClient.session.exists()];
                    case 1:
                        if (!_a.sent()) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.authClient.tokenManager.get('idToken')];
                    case 2:
                        idToken = _a.sent();
                        return [4 /*yield*/, this.authClient.tokenManager.get('accessToken')];
                    case 3:
                        accessToken = _a.sent();
                        return [2 /*return*/, new model_1.UserSession(new model_1.JWTToken(idToken.value), new model_1.JWTToken(accessToken.value), ' ')];
                    case 4: throw new auth_error_1.default(constants_1.AuthMessageEnum.USER_NOT_LOGGEDIN, constants_1.ErrorCodeEnum.USER_NOT_LOGGEDIN);
                }
            });
        });
    };
    /**
     *
     * @param user Update user attributes
     * @param attributes
     */
    OktaAuthProvider.prototype.updateUserAttributes = function (user, attributes) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, 'SUCCESS'];
            });
        });
    };
    return OktaAuthProvider;
}());
exports.OktaAuthProvider = OktaAuthProvider;
var oktaProvider;
var createOktaProvider = function (config) {
    if (oktaProvider === null || oktaProvider === undefined) {
        oktaProvider = new OktaAuthProvider(config);
    }
    return oktaProvider;
};
var configureOkta = function (config) { };
exports.default = createOktaProvider;
//# sourceMappingURL=okta.auth.provider.js.map